import { Icon, ListDescription, ListItem, useScreenSize } from '@alto/design-system';
import { useNavigation } from '@alto/navigation';
import React from 'react';
// eslint-disable-next-line import/no-deprecated
import fetchQuantityOptions from '~shared/actions/quantityOptions';
import { closeCart } from '~shared/actions/ui/cart';
import { getPlatformOS } from '~shared/helpers/getPlatformOS';
import { formatQuantity } from '~shared/helpers/helper';
import { sendAnalyticsEvent } from '~shared/lib/analytics/src/actions';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { ORIGIN_NAMES } from '~shared/lib/analytics/src/getOrigin';
import { createEvent } from '~shared/lib/analytics/src/helper';
import { getIsCartShowing } from '~shared/selectors/ui/cart';
import { useDispatchShared, useSelectorShared } from '~shared/store';
import { type Prescription } from '~shared/types';

type ChangeMedicationItemQuantityProps = {
  readonly prescription: Prescription;
  readonly handleClose: () => void;
};

export const ChangeMedicationItemQuantity = ({ prescription, handleClose }: ChangeMedicationItemQuantityProps) => {
  const { navigate } = useNavigation();

  const dispatch = useDispatchShared();
  const isCartShowing = useSelectorShared(getIsCartShowing);
  const { isSMScreen } = useScreenSize();
  const platformOS = getPlatformOS();
  const prescriptionID = prescription.id;

  const onPress = () => {
    dispatch(
      sendAnalyticsEvent(
        createEvent(
          EVENTS.QUANTITY_CHANGE_INITIATED,
          {
            origin: ORIGIN_NAMES.CART,
          },
          { prescriptionId: prescriptionID },
        ),
      ),
    );

    // If we are on mobile web and cart is showing, then we need to close the cart before navigating
    if (isSMScreen && isCartShowing && platformOS === 'web') {
      dispatch(closeCart());
    }
    // eslint-disable-next-line import/no-deprecated
    dispatch(fetchQuantityOptions(prescriptionID));
    navigate('RouteChangeQuantity', {
      prescriptionID,
    });
    handleClose();
  };

  return (
    <ListItem
      title="Quantity"
      LeftContent={<Icon name="pillbottle" />}
      RightContent={<Icon name="chevronright" />}
      descriptions={<ListDescription>{formatQuantity(prescription)}</ListDescription>}
      onPress={onPress}
    />
  );
};
